import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.5 6.042c0-.92.747-1.667 1.667-1.667h11.666c.92 0 1.667.747 1.667 1.667v8.333c0 .92-.747 1.667-1.667 1.667H4.167c-.92 0-1.667-.748-1.667-1.667zm3.333 5a.832.832 0 1 0 0-1.667.832.832 0 1 0 0 1.667m.834-3.334a.832.832 0 1 0-1.667 0 .832.832 0 1 0 1.667 0m-.834 5.834a.832.832 0 1 0 0-1.667.832.832 0 1 0 0 1.667m2.5-6.459a.624.624 0 0 0-.625.625c0 .347.279.625.625.625h5.834a.624.624 0 0 0 .625-.625.624.624 0 0 0-.625-.625zm0 2.5a.623.623 0 0 0-.625.625c0 .347.279.625.625.625h5.834a.624.624 0 0 0 .625-.625.624.624 0 0 0-.625-.625zm0 2.5a.624.624 0 0 0-.625.625c0 .347.279.625.625.625h5.834a.624.624 0 0 0 .625-.625.624.624 0 0 0-.625-.625z"
    }, null, -1)
  ]))]))
}
export default { render: render }